import { useContext } from 'react';
import { ModalContext } from 'components/core/modal/Context';

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error(
      'useModal must be used within <ModalProvider /> check render in components/AppContainer',
    );
  }

  return context;
};

export default useModal;
